import * as React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';

import { IDefaultProps, TString } from '../../types';
import {
  ErrorDescription,
  ErrorHeader,
  ErrorTitle,
  ErrorContainer,
} from './Error.styles';

interface IErrorPageProps extends IDefaultProps {
  title: TString;
  description?: TString;
  onClick?: (event: React.MouseEvent) => void;
}

export const ErrorPage: React.FC<IErrorPageProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <ErrorContainer>
      <ErrorHeader>Something went wrong</ErrorHeader>
      <ErrorTitle>{title}</ErrorTitle>
      {description && <ErrorDescription>{description}</ErrorDescription>}
      {onClick && <ApButtonMain onClick={onClick}>Try again</ApButtonMain>}
    </ErrorContainer>
  );
};
